import { gql } from "@apollo/client";
import { PageDataFragment } from "@/fragments/PageData";

export const InducteeLandingQuery = gql`
  ${PageDataFragment}
  query GetInducteeLanding($databaseId: ID!, $asPreview: Boolean = false, $language: String = "en") {
    rhPage(id: $databaseId, asPreview: $asPreview, language: $language) {
      title
      ...PageData
      inducteeLanding {
        headline
        searchPlaceholder
        aZLabel
        byClassLabel
        noResultsTitle
        noResultsBody
        primaryCardCta {
          linkType
          externalLink
          label
          page {
            node {
              uri
            }
          }
        }
        noResultsCta {
          linkType
          externalLink
          label
          page {
            node {
              uri
            }
          }
        }
      }
    }
  }
`;
